import React from "react";
import s from "../../labReport/labReportPdf.module.scss";

const SeminalFluidAnalysisPdf = ({ profile, PageBaseLayout, PageFooter }) => {
  if (!profile) return null;

  const filterTests = (keywords) => {
    return profile.tests.filter((t) =>
      keywords.some((key) =>
        t.testName.toLowerCase().includes(key.toLowerCase()),
      ),
    );
  };

  const physicalTests = filterTests([
    "Collection Time",
    "Lequefaction Time",
    "Abstinence",
    "Quantity",
    "Colour",
    "Viscosity",
    "Reaction",
  ]);

  const microscopicTests = filterTests([
    "Total Sperm Count",
    "Actively Motile",
    "Sluggishly Motile",
    "Non Motile",
  ]);

  const morphologyTests = filterTests(["Normal forms", "Abnormal forms"]);

  // Baki saare tests (pus cells, RBCs, Impression etc.) yahan handle honge
  const otherTests = profile.tests.filter(
    (t) =>
      !physicalTests.includes(t) &&
      !microscopicTests.includes(t) &&
      !morphologyTests.includes(t),
  );

  const RenderSection = ({ title, tests }) => (
    <>
      <tr className={s.sectionHeaderRow}>
        <td
          colSpan="4"
          style={{
            fontWeight: "bold",
            backgroundColor: "#f2f2f2",
            padding: "5px",
          }}
        >
          {title}
        </td>
      </tr>
      {tests.map((t, idx) => (
        <tr key={idx}>
          <td style={{ paddingLeft: "15px" }}>{t.testName} </td>
          <td align="center">{t.value || "-"} </td>
          <td align="center"></td>
          <td align="center"></td>
        </tr>
      ))}
    </>
  );

  return (
    <div className={s.reportPage} style={{ pageBreakAfter: "always" }}>
      <PageBaseLayout showSampleType={true} currentSampleType={profile.sampleType} />
      <div className={s.testCategoryHeader}>
        {profile.profileName?.toUpperCase()}
      </div>

      <table className={s.resultsTable}>
        <thead>
          <tr>
            <th style={{ width: "40%" }}>Test Description</th>
            <th style={{ textAlign: "center" }}>Value(s)</th>
            <th style={{ textAlign: "center" }}>Unit(s)</th>
            <th style={{ textAlign: "center" }}>Reference Range</th>
          </tr>
        </thead>
        <tbody>
          {physicalTests.length > 0 && (
            <RenderSection title="PHYSICAL EXAMINATION" tests={physicalTests} />
          )}
          {microscopicTests.length > 0 && (
            <RenderSection
              title="MICROSCOPIC DESCRIPTION"
              tests={microscopicTests}
            />
          )}
          {morphologyTests.length > 0 && (
            <RenderSection title="MORPHOLOGY" tests={morphologyTests} />
          )}
          {otherTests.length > 0 && (
            <RenderSection title="OTHERS" tests={otherTests} />
          )}
        </tbody>
      </table>

      <PageFooter />
    </div>
  );
};

export default SeminalFluidAnalysisPdf;
